export const tr = {
    cancel: 'İptal',
    down: 'küçült',
    error: 'Teklifi en fazla  %{percent} oranında {change} mümkündür.',
    max: 'maks.',
    min: 'min.',
    'rate-string': 'Teklifi {change}: %{percent}',
    save: 'Tamam',
    up: 'arttır'
};
